import { FC } from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import illustration from '@svg/illustrations/loading_kyc.svg';
import Button from '@components/common/button';
import { useLocales } from '@hooks/helpers/useLocales';

interface IProps {
    onClose: () => void;
}

const KycLoading: FC<IProps> = ({ onClose }) => {
    const { submitLocale } = useLocales();
    return (
        <div className={styles.loading_wrapper}>
            <img src={illustration} alt="" />
            <Typography className={styles.title} variant="h4" alignment="center">
                Your verification is being processed now
            </Typography>
            <Typography className={styles.descriptions} variant="body3" alignment="center">
                We'll need a few minutes to verify your identity. You'll receive a notification once
                the process is complete
            </Typography>
            <div className={styles.actions}>
                <Button variant="primary" onClick={onClose}>
                    {submitLocale('done')}
                </Button>
            </div>
        </div>
    );
};

export default KycLoading;
